import * as React from 'react';
import Icon from '../Icon';


var MoreInfoIcon = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(Icon, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", className: 'MoreInfoIcon', onClick: onClick },
        React.createElement("path", { d: "M12 2H5.6C5.17566 2 4.76869 2.16857 4.46863 2.46863C4.16857 2.76869 4 3.17566 4 3.6V16.4C4 16.8243 4.16857 17.2313 4.46863 17.5314C4.76869 17.8314 5.17566 18 5.6 18H15.2C15.6243 18 16.0313 17.8314 16.3314 17.5314C16.6314 17.2313 16.8 16.8243 16.8 16.4V6.8M12 2L16.8 6.8M12 2V6.8H16.8M13.6 14H7.2M13.6 10.8H7.2M8.8 7.6H7.2", stroke: "#111111", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default React.memo(MoreInfoIcon);
